/* Jackler 7.23 (Dan, 2026-10-12, "try the 1 clear button"): the phone sticky add-to-cart bar
   and the "no pre-picked size" guard. Markup + styles: snippets/product-add-to-cart-sticky.liquid.
   - Bar button: SELECT SIZE (opens the size sheet) / ADD TO CART [size] (adds) /
     CHANGE SIZE (the chosen size is sold out) / VIEW CART for a few seconds after an add.
   - Sheet: the sticky option panel shown as a bottom sheet over a dimmed page. Tapping a
     size there adds it straight away (the same "tap a size to add" as the grid quick-add).
   - Guard: while the Size option has nothing chosen, submitting the main form (ADD TO CART or
     Buy with Shop) points at the size buttons instead of adding a size nobody chose.
   Every add goes through the main product form, so the theme's ProductForm, its
   cart:item-added event and Shopify's analytics events all stay as they were. */
(function () {
  'use strict';
  const host = document.querySelector('product-add-to-cart-sticky');
  const mainVS = document.querySelector('variant-selects:not([data-sticky])');
  const section = (host && host.dataset.section) || (mainVS && mainVS.dataset.section);
  if (!section) return;
  const form = document.getElementById('product-form-' + section);
  if (!form) return;
  const $ = (sel, root) => (root || document).querySelector(sel);
  const phone = window.matchMedia('(max-width: 767px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SHEET_DELAY = () => (reduce.matches ? 250 : 650);

  /* ---------- state ---------- */
  let ourAdd = null;      // set when the main form really submits (from any button)
  let pendingAdd = null;  // a size tapped in the sheet, waiting for its variant to resolve
  let resolving = false;  // a variant change is being fetched by product.js
  let resolveTimer = 0;
  let added = null;       // { text } while the bar says "Added to cart"
  let addedTimer = 0;
  let loading = false;
  let submitTimer = 0;
  let lastFocus = null;

  /* ---------- the Size option ---------- */
  const sizeFieldset = () => mainVS && mainVS.querySelector('fieldset[data-handle="size"]');
  const hasSize = () => { const fs = sizeFieldset(); return !!fs && fs.querySelectorAll('input[type=radio]').length > 1; };
  const sizeValue = () => { const fs = sizeFieldset(); const c = fs && fs.querySelector('input:checked'); return c ? c.value : null; };
  const sizePending = () => hasSize() && !sizeValue();
  const multiChoice = () => !!mainVS && [...mainVS.querySelectorAll('fieldset')].some((fs) => fs.querySelectorAll('input[type=radio]').length > 1);
  const idInput = form.querySelector('input[name="id"]');
  let variants = [];
  try { variants = JSON.parse(((host && $('variant-selects script[type="application/json"]', host)) || {}).textContent || '[]'); } catch (e) { variants = []; }
  // The resolved variant is whatever id product.js last wrote into the form.
  function variant() {
    const id = idInput ? parseInt(idInput.value, 10) : 0;
    const v = variants.find((x) => x.id === id);
    if (v) return { id, available: v.available, options: v.options };
    return (mainVS && mainVS.currentVariant) || null;
  }

  /* ---------- guard: no add while no size is chosen ---------- */
  function nudge() {
    const fs = sizeFieldset();
    if (!fs) return;
    fs.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' });
    fs.classList.add('jk-size-nudge');
    let note = fs.querySelector('.jk-size-msg');
    if (!note) { note = document.createElement('p'); note.className = 'jk-size-msg'; note.setAttribute('role', 'status'); fs.appendChild(note); }
    note.textContent = 'Choose a size first.';
    clearTimeout(nudge.t);
    nudge.t = setTimeout(() => fs.classList.remove('jk-size-nudge'), 1600);
  }
  function clearNudge() {
    const fs = sizeFieldset();
    if (!fs) return;
    fs.classList.remove('jk-size-nudge');
    const note = fs.querySelector('.jk-size-msg');
    if (note) note.remove();
  }
  // Capture on document runs before ProductForm's own submit listener on the form.
  document.addEventListener('submit', (e) => {
    if (e.target !== form) return;
    if (sizePending()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
      return;
    }
    ourAdd = { size: hasSize() ? sizeValue() : null, at: Date.now() };
  }, true);
  // Buy with Shop buys whatever variant the form holds: hold it until a size is chosen.
  ['pointerdown', 'click'].forEach((type) => document.addEventListener(type, (e) => {
    if (!sizePending()) return;
    const pay = e.target && e.target.closest && e.target.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button');
    if (!pay || !form.contains(pay)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (type === 'click') nudge();
  }, true));
  const syncPay = () => form.classList.toggle('jk-pay-wait', sizePending());

  /* ---------- phone bar ---------- */
  const bar = host && $('[data-jk-sbar]', host);
  const cta = bar && $('[data-jk-cta]', bar);
  const ctaLabel = cta && $('.jk-sbar__label', cta);
  const ctaSize = cta && $('.jk-sbar__size', cta);
  const view = bar && $('.jk-sbar__view', bar);
  const info = bar && $('.jk-sbar__info', bar);
  const status = bar && $('.jk-sbar__status', bar);
  const title = bar && $('.jk-sbar__title', bar);
  const titleText = title ? title.textContent : '';
  const live = bar && $('[data-jk-live]', bar);
  const sheet = host && $('.product-add-to-cart-sticky--content', host);
  const scrim = host && $('[data-jk-scrim]', host);
  const msg = host && $('[data-jk-msg]', host);
  const stickyVS = host && $('variant-selects', host);
  const isOpen = () => !!host && host.classList.contains('jk-open');

  function mirror() {
    // Copies of the thumbnail and price for the bar and the sheet head (product.js re-renders the originals).
    const src = $('#product-image-' + section + '--sticky img');
    if (src) {
      const url = src.currentSrc || src.src;
      host.querySelectorAll('.jk-sbar__thumb, .jk-sheet__thumb').forEach((box) => {
        const cur = box.querySelector('img');
        if (cur && cur.getAttribute('src') === url) return;
        const img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.width = 88;
        img.height = 104;
        box.replaceChildren(img);
      });
    }
    const price = document.getElementById('price-' + section + '--sticky');
    const sp = host.querySelector('[data-jk-sheet-price]');
    if (price && sp && sp.innerHTML !== price.innerHTML) sp.innerHTML = price.innerHTML;
  }

  function setCta(label, opts) {
    opts = opts || {};
    ctaLabel.textContent = label;
    ctaSize.hidden = !opts.size;
    ctaSize.textContent = opts.size || '';
    cta.classList.toggle('is-line', !!opts.line);
    cta.classList.toggle('is-off', !!opts.off);
    cta.disabled = !!opts.off;
    cta.dataset.action = opts.action || '';
    cta.setAttribute('aria-label', opts.size ? label + ', size ' + opts.size : label);
    if (opts.action === 'sheet') {
      cta.setAttribute('aria-haspopup', 'dialog');
      cta.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    } else {
      cta.removeAttribute('aria-haspopup');
      cta.removeAttribute('aria-expanded');
    }
  }
  function setStatus(text, warn) {
    bar.classList.toggle('is-status', !!text);
    status.hidden = !text;
    status.textContent = text || '';
    status.classList.toggle('is-warn', !!warn);
  }

  function render() {
    syncPay();
    if (!bar) return;
    cta.classList.toggle('is-loading', loading);
    cta.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (added) {
      bar.classList.add('is-added');
      title.textContent = 'Added to cart';
      setStatus(added.text, false);
      cta.hidden = true;
      view.hidden = false;
      return;
    }
    bar.classList.remove('is-added');
    title.textContent = titleText;
    cta.hidden = false;
    view.hidden = true;
    if (bar.dataset.error) { setStatus(bar.dataset.error, true); }
    const v = variant();
    const sized = hasSize();
    const size = sizeValue();
    if (sized && !size) {
      if (!bar.dataset.error) setStatus('');
      setCta('Select size', { action: 'sheet' });
    } else if (v && v.available === false && !resolving) {
      if (sized) {
        setStatus(size + ' is sold out', true);
        setCta('Change size', { action: 'sheet', line: true });
      } else if (multiChoice()) {
        setStatus('Sold out in this option', true);
        setCta('Change', { action: 'sheet', line: true });
      } else {
        setStatus('');
        setCta('Sold out', { off: true });
      }
    } else {
      if (!bar.dataset.error) setStatus('');
      if (!sized && multiChoice()) setCta('Add to cart', { action: 'sheet' });
      else setCta('Add to cart', { action: 'add', size: sized ? size : '' });
    }
  }
  function flashError(text) {
    if (!bar) return;
    bar.dataset.error = text;
    render();
    clearTimeout(flashError.t);
    flashError.t = setTimeout(() => { delete bar.dataset.error; render(); }, 5000);
  }

  /* ---------- sheet ---------- */
  // The bar sits inside the product section, whose wrappers make their own stacking layers
  // (z-index 1 and 31). Lift those while the sheet is open so the dimmed backdrop and the
  // sheet cover everything else on the page (header, the 15% tab, chat bubbles).
  function lift(on) {
    if (!on) { document.querySelectorAll('.jk-lift').forEach((el) => el.classList.remove('jk-lift')); return; }
    for (let el = host.parentElement; el && el !== document.body; el = el.parentElement) {
      const cs = getComputedStyle(el);
      if (cs.zIndex !== 'auto' && cs.position !== 'static') el.classList.add('jk-lift');
    }
  }
  function openSheet() {
    if (!host || !sheet || !phone.matches) return;
    lastFocus = document.activeElement;
    host.classList.toggle('jk-confirm', !hasSize());
    lift(true);
    host.classList.remove('jk-sbar-off'); // 7.25: the sheet only opens from the bar, so the bar is showing
    host.classList.add('jk-open');
    document.documentElement.classList.add('jk-sheet-lock');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', hasSize() ? 'Choose your size' : 'Choose options');
    sheet.scrollTop = 0;
    if (msg) msg.textContent = '';
    mirror();
    render();
    const x = $('[data-jk-close]', sheet);
    setTimeout(() => { try { x.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, reduce.matches ? 0 : 80);
  }
  function closeSheet() {
    if (!isOpen()) return;
    host.classList.remove('jk-open');
    document.documentElement.classList.remove('jk-sheet-lock');
    lift(false);
    sheet.removeAttribute('role');
    sheet.removeAttribute('aria-modal');
    pendingAdd = null;
    sheet.querySelectorAll('.jk-adding, .jk-added').forEach((l) => l.classList.remove('jk-adding', 'jk-added'));
    render();
    applyBar(); // 7.25: catch up with any scroll that happened behind the sheet
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }

  function submit() {
    if (loading) return;
    loading = true;
    render();
    clearTimeout(submitTimer);
    submitTimer = setTimeout(() => { if (loading) failed("Couldn't add. Please try again."); }, 12000);
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    // The guard may have refused it (no size): nothing is loading then.
    if (!ourAdd) { loading = false; clearTimeout(submitTimer); render(); }
  }
  function failed(text) {
    loading = false;
    ourAdd = null;
    clearTimeout(submitTimer);
    if (pendingAdd && pendingAdd.label) pendingAdd.label.classList.remove('jk-adding');
    pendingAdd = null;
    if (live) live.textContent = text;
    if (isOpen() && msg) { msg.textContent = text; render(); }
    else flashError(text);
  }

  // A size tapped in the sheet: add it once its variant has resolved.
  function tryPendingAdd() {
    if (!pendingAdd || resolving || pendingAdd.sent) return;
    const v = variant();
    if (!v || sizeValue() !== pendingAdd.size) return;
    if (v.available === false) {
      if (pendingAdd.label) pendingAdd.label.classList.remove('jk-adding');
      const others = (v.options || []).filter((o) => o !== pendingAdd.size);
      pendingAdd = null;
      if (msg) msg.textContent = sizeValue() + ' is sold out' + (others.length ? ' in ' + others[0] : '') + '. Pick another size.';
      render();
      return;
    }
    pendingAdd.sent = true;
    submit();
  }

  if (host && bar && cta) {
    mirror();
    const imgBox = document.getElementById('product-image-' + section + '--sticky');
    if (imgBox) new MutationObserver(mirror).observe(imgBox, { childList: true, subtree: true });
    const priceEl = document.getElementById('price-' + section + '--sticky');
    if (priceEl) new MutationObserver(mirror).observe(priceEl, { childList: true, subtree: true, characterData: true });
    const fine = $('[data-jk-fine]', host);
    if (fine) fine.hidden = !hasSize();
    const chart = $('[data-jk-chart]', host);
    const chartWrap = $('.sizing-chart-btn-wrap');
    if (chart && chartWrap && hasSize()) {
      chart.hidden = false;
      chart.addEventListener('click', () => {
        closeSheet();
        const summary = chartWrap.querySelector('summary');
        if (!chartWrap.open && summary) summary.click();
        chartWrap.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      });
    }

    cta.addEventListener('click', () => {
      const action = cta.dataset.action;
      if (action === 'sheet') { openSheet(); return; }
      if (action !== 'add') return;
      delete bar.dataset.error;
      if (resolving) { pendingAdd = { size: sizeValue(), label: null }; loading = true; render(); return; }
      submit();
    });
    if (info && info.tagName === 'BUTTON') info.addEventListener('click', openSheet);
    if (scrim) scrim.addEventListener('click', closeSheet);
    const x = $('[data-jk-close]', host);
    if (x) x.addEventListener('click', closeSheet);
    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key !== 'Tab') return;
      // keep keyboard focus inside the open sheet
      const f = [...sheet.querySelectorAll('button:not([disabled]), input[type=radio], a[href]')].filter((el) => !el.closest('[hidden]') && (el.offsetParent || el.type === 'radio'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    const onWidth = () => { if (!phone.matches) closeSheet(); };
    if (phone.addEventListener) phone.addEventListener('change', onWidth);

    // Tapping a size in the sheet adds it.
    if (stickyVS) {
      stickyVS.addEventListener('click', (e) => {
        if (!isOpen()) return;
        const label = e.target.closest('label');
        if (!label) return;
        const input = document.getElementById(label.htmlFor);
        const fs = input && input.closest('fieldset');
        if (!fs || fs.dataset.handle !== 'size') return;
        if (pendingAdd || loading) { e.preventDefault(); return; }
        if (msg) msg.textContent = '';
        sheet.querySelectorAll('.jk-added').forEach((l) => l.classList.remove('jk-added'));
        label.classList.add('jk-adding');
        pendingAdd = { size: input.value, label: label };
        // Already the chosen size: no change event will come, so add right away.
        if (input.checked) tryPendingAdd();
      });
    }
  }

  /* ---------- 7.25: when the phone bar shows ----------
     Dan (2026-10-13): "I don't want it appearing when you obviously have the actual variant selectors
     or the actual add to cart button in sight ... it clogs up the screen". On phones the bar slides
     away while any part of the real options (the main variant-selects) or the real ADD TO CART
     (#AddToCart) is on screen below the sticky header, and slides back only once both are fully off
     screen, above or below. Two IntersectionObservers give it a 32 px dead band (HYST) so it can't
     flicker at the edge: the "in view" one hides it, the "near" one (the same area grown by 32 px
     top and bottom) must be clear before it comes back. While the size sheet is open nothing changes.
     Desktop never gets the class (its styles live in the phone media query of the snippet). */
  const HYST = 32;
  const watched = [mainVS, document.getElementById('AddToCart')].filter((el) => el && !(host && host.contains(el)));
  let barWanted = true;     // what the observers last asked for
  let barSettle = 0;
  function applyBar(instant) {
    if (!host || !bar) return;
    if (isOpen()) return; // the sheet is open: leave the bar exactly as it is
    const off = phone.matches && !barWanted;
    if (host.classList.contains('jk-sbar-off') === off) return;
    if (instant) host.classList.add('jk-sbar-instant');
    host.classList.remove('jk-sbar-still');
    host.classList.toggle('jk-sbar-off', off);
    host.setAttribute('aria-hidden', off ? 'true' : 'false');
    if (instant) requestAnimationFrame(() => requestAnimationFrame(() => host.classList.remove('jk-sbar-instant')));
    // jk-offer-tab re-measures on the bar's class changes; tell it again once the slide has finished
    clearTimeout(barSettle);
    barSettle = setTimeout(() => host.classList.add('jk-sbar-still'), instant || reduce.matches ? 0 : 320);
  }
  if (host && bar && watched.length && 'IntersectionObserver' in window) {
    const inView = new Set();
    const near = new Set();
    let ioIn = null, ioNear = null, topCut = -1, first = true, heard = new Set();
    const header = document.querySelector('theme-header');
    const headerCut = () => (header && header.classList.contains('header-sticky--active') ? Math.round(header.getBoundingClientRect().height) : 0);
    const decide = () => {
      if (heard.size < 2) return; // wait for both observers' first report after a (re)build
      if (inView.size) barWanted = false;
      else if (!near.size) barWanted = true;
      // anything else: inside the dead band, keep the current state
      applyBar(first);
      first = false;
    };
    const track = (set) => (entries, io) => {
      heard.add(io);
      entries.forEach((e) => { if (e.isIntersecting) set.add(e.target); else set.delete(e.target); });
      decide();
    };
    const build = () => {
      const cut = headerCut();
      if (cut === topCut) return;
      topCut = cut;
      if (ioIn) ioIn.disconnect();
      if (ioNear) ioNear.disconnect();
      inView.clear();
      near.clear();
      heard = new Set();
      ioIn = new IntersectionObserver(track(inView), { rootMargin: -cut + 'px 0px 0px 0px', threshold: 0 });
      ioNear = new IntersectionObserver(track(near), { rootMargin: (HYST - cut) + 'px 0px ' + HYST + 'px 0px', threshold: 0 });
      watched.forEach((el) => { ioIn.observe(el); ioNear.observe(el); });
    };
    build();
    // The header can change height (announcement bar collapsing, fonts): re-cut the top edge.
    if (header && 'ResizeObserver' in window) new ResizeObserver(() => { clearTimeout(build.t); build.t = setTimeout(build, 100); }).observe(header);
    if (phone.addEventListener) phone.addEventListener('change', () => applyBar(true));
  }

  /* ---------- theme events ---------- */
  document.addEventListener('product:variant-change', (e) => {
    if (e.detail && e.detail.sectionId && e.detail.sectionId !== section) return;
    resolving = true;
    clearNudge();
    if (added) { added = null; clearTimeout(addedTimer); }
    render();
    clearTimeout(resolveTimer);
    resolveTimer = setTimeout(() => {
      if (!resolving) return;
      resolving = false;
      if (pendingAdd) failed("Couldn't add. Please try again.");
      else render();
    }, 8000);
  });
  // product.js writes the resolved variant id into the form and fires "change" on it.
  if (idInput) idInput.addEventListener('change', () => {
    resolving = false;
    clearTimeout(resolveTimer);
    render();
    tryPendingAdd();
  });
  document.addEventListener('cart:item-added', (e) => {
    if (!ourAdd) return;
    const item = e.detail && e.detail.product;
    const was = ourAdd;
    ourAdd = null;
    loading = false;
    clearTimeout(submitTimer);
    let text = '';
    if (was.size) text = 'Size ' + was.size;
    else if (item && item.variant_title && item.variant_title !== 'Default Title') text = item.variant_title.split(' / ').filter((t) => !/^one size$/i.test(t)).join(' / ');
    if (pendingAdd && pendingAdd.label) { pendingAdd.label.classList.remove('jk-adding'); pendingAdd.label.classList.add('jk-added'); }
    pendingAdd = null;
    if (!bar) return;
    added = { text };
    if (live) live.textContent = 'Added to cart' + (text ? ', ' + text : '');
    if (isOpen()) setTimeout(closeSheet, SHEET_DELAY());
    render();
    clearTimeout(addedTimer);
    addedTimer = setTimeout(() => { added = null; render(); }, 6000);
  });
  document.addEventListener('product:variant-error', (e) => {
    if (!ourAdd) return;
    const d = (e && e.detail) || {};
    failed(typeof d.errors === 'string' ? d.errors : (d.message || "Couldn't add. Please try again."));
  });

  render();
})();
